import React from 'react';
import { hot } from 'react-hot-loader';
import s from './Select.scss';

const Select = ({ id, options, selected, inputChange, disabledKey = 'disabled', inputBlur = () => {}, isError = false, label = null }) => {
	const inputChangeHandlar = (e) => {
		e.preventDefault();
		const $input = e.currentTarget;
		inputChange($input.id, $input.value);
	};

	const inputBlurHandlar = (e) => {
		e.preventDefault();
		const $input = e.currentTarget;
		inputBlur($input.id, $input.value);
	};

	const labelClasses = [];
	if (isError) labelClasses.push(s.label__error);

	label = label || null;

	const select = (
		<div className={[s.select, s[`select__${id}`]].join(' ')}>
			<select name={id} id={id} onChange={inputChangeHandlar} onBlur={inputBlurHandlar} value={selected}>
				{
					options.map((option) => (typeof option === 'object' ? <option key={option.key} value={option.key} disabled={option[disabledKey] ? true : null}>{option.value}</option> : <option key={option} value={option}>{option}</option>))
				}
			</select><svg xmlns="http://www.w3.org/2000/svg" width="14" height="8" viewBox="0 0 14 8"><polyline points="1167 1513 1173 1519 1179 1513" transform="translate(-1166 -1512)" /></svg>
		</div>
	);

	return (
		label ? (
			<label className={labelClasses.join(' ')} htmlFor={id}>
				<span className={s.label_title}>{ label }</span>
				{ select }
			</label>
		) : (
			<div>
				{ select }
			</div>
		)
	);
};

export default hot(module)(Select);
